import { IonCard, IonCardContent, IonCol, IonIcon, IonRow } from "@ionic/react";
import React, { FC } from "react";
import {default as find_customers_icon} from "../../../AE2/static/icons/actions_row/Find Customers.svg"
import {default as success_stories_icon} from "../../../AE2/static/icons/actions_row/View Success Stories.svg"
import {default as side_arrow_icon} from "../../../AE2/static/icons/actions_row/Side Arrow.svg"
import {default as report_icon} from "../../../AE2/static/icons/actions_row/Run a Report.svg"
import {default as data_operations_icon} from "../../../AE2/static/icons/actions_row/Data Operations.svg"
import './ActionsRow.css'
import { isMobile } from "react-device-detect";
import { useWindowWidth } from "../../../utils/useWindowWidth";

interface IProps {};

interface Item{
    'icon': any,
    'title':string,
    'subtext':string,
    'url':string
}

const items = [
    {
        'icon':find_customers_icon,
        'title':'Find Customers',
        'subtext':'Search and explore customers profiles',
        'url':''
    },
    {
        'icon':success_stories_icon,
        'title':'View Success Stories',
        'subtext':'See real results from our customers',
        'url':'/success_stories'
    },
    {
        'icon':report_icon,
        'title':'Run a Report',
        'subtext':'Benchmark, savings, and performance reports',
        'url':''
    },
    {
        'icon': data_operations_icon,
        'title': 'Data Operations',
        'subtext': 'Refresh data and trigger compute processes',
        'url':'/data-operations'
    }
]

const ActionsRow:FC<IProps> = (props) => {
    const width = useWindowWidth()
    return <IonRow className="actions-row" style={{minHeight:'100px'}}>

        { items.map((item:Item)=> {

        


        return (
        <IonCol size='3' key={item.title} >
            {isMobile ||  width < 1200 ?  
                <div className="card-content-mobile">
                    <img src={item.icon} alt='icon'/>
                    <h4 className="text-map-main font-helvetica font-bold font-10pt"> {item.title}</h4>
                </div>
                :
            <IonCard className="grey-border-2pt" href={item.url}>                
                <IonCardContent>                
                    <IonIcon src={item.icon} slot="start"/>                    
                    <div className="quick-actions__text ">
                        <h3 className="text-map-main font-helvetica font-bold font-13pt">{item.title}</h3>
                        <p className="text-footer-blue font-helvetica font-med font-12pt">{item.subtext}</p>
                    </div>
                    <IonIcon className="arrow_icon" src={side_arrow_icon} slot="end"></IonIcon>
                </IonCardContent>                             
            </IonCard>
            }
        </IonCol>)}
        )}
    </IonRow>
};

export default ActionsRow;